<!-- MENU -->
<!-- Fixed navbar -->
<nav class="navbar navbar-default navbar-fixed-top">
    <div class="container">
        <div class="navbar-header">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
				<span class="sr-only">Toggle navigation</span>
				<span class="icon-bar"></span>	
				<span class="icon-bar"></span>
				<span class="icon-bar"></span>
			</button>
            <a class="navbar-brand" href="index.php?p=sew">FileDOM WEB{{name}}</a>
        </div>
        <div id="navbar" class="navbar-collapse collapse">
            <ul class="nav navbar-nav">
                <li class="active"><a class="hvr-underline-from-center" href="index.php?p=sew">Inicio</a></li>
                <li class="dropdown">
                    <a class="hvr-underline-from-center" href="#" data-toggle="dropdown" class="dropdown-toggle">Solicitudes<b class="caret"></b></a>
                    <ul class="dropdown-menu" id="menu1">
                        <li><a class="hvr-shutter-out-horizontal" href="index.php?p=tramites"><i class="fa fa-file-text" aria-hidden="true"></i> Nueva Solicitud</a></li>
                        <!-- <li><a class="hvr-shutter-out-horizontal" href="index.php?p=solicitudes1"><i class="fa fa-file-text" aria-hidden="true"></i>Otro Formato</a></li> -->
                    </ul>
                </li>
            </ul>
            <ul class="nav navbar-nav navbar-right">
                <li class="dropdown">
                    <a href="#" class="dropdown-toggle hvr-underline-from-center" data-toggle="dropdown" role="button" aria-expanded="false"><span class="glyphicon glyphicon-user" aria-hidden="true"></span> Bienvenido(a) <span id="user-name-label-span"></span><span class="caret"></span></a>
                    <ul class="dropdown-menu" role="menu">
                        <li><a class="hvr-shutter-out-horizontal" href="index.php?p=profile">Perfil</a></li>
                        <li><a class="hvr-shutter-out-horizontal" href="index.php?p=tramites">Mis tr&aacute;mites</a></li>
                        <li><a class="hvr-shutter-out-horizontal" href="index.php?p=close_session"><span class="glyphicon glyphicon-log-out" aria-hidden="true"></span> Cerrar sesi&oacute;n</a></li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</nav>
<!-- FIN MENU -->